export const FEATURE_FLAGS = {
  ENABLE_CUSTOM_MAIL: true,
  ENABLE_VALIDATE_WHOLE_SALE: false, // Feedback No 35
  ENABLE_DASHBOARD: true,
  ENABLE_COUNT_SETTING_NUMBER: true
} as const;
